module.exports = __webpack_public_path__ + "static/media/maid.1487e74c.svg";